module.exports = __webpack_public_path__ + "static/fonts/nf.92f6794e.eot";